import React from 'react'
import { Route } from 'react-router-dom'
import VerifyLogin from './VerifyLogin'

// prettier-ignore
export default (
  <Route path="/verify-login/:token" element={<React.Suspense><VerifyLogin /></React.Suspense>} />
)
